<template>
    <f-app-screen>
        <div class="pt-12 px-14 grow flex flex-col items-center justify-start">
            <div class="flex-initial h-1/5"></div>

            <div class="flex items-center flex-col shrink-0">
                <img
                        src="@/assets/forex-hero-splash-logo.svg"
                        alt="Forex Hero"
                />
                <div class="text-slate-blue-100 mt-4 text-base text-center">Build real skills for wealth, not just trades.</div>
            </div>

            <div class="mt-12 flex flex-col items-center justify-start gap-12">
                    <proof v-if="showProof[1]" :style="{ '--animate-delay': '0.2s' }">
                        <transition appear enter-active-class="animate__animated animate__fadeInUp animate__faster animate__delay-2s">
                            <div class="text-base xs:text-xl text-center basis-44 w-44" >
                                <span class="font-extrabold text-xl xs:text-3xl">Millions</span><br/>
                                of users worldwide<br/>
                                since 2014
                            </div>
                        </transition>
                    </proof>

                    <proof v-if="showProof[2]" :style="{ '--animate-delay': '0.2s' }">
                        <transition
                                appear
                                enter-from-class="invisible"
                                enter-active-class="animate__animated animate__fadeInUp animate__faster animate__delay-2s"
                        >
                            <div class="text-base xs:text-xl text-center basis-44 w-44">
                                <span class="font-extrabold text-xl xs:text-3xl">Research</span><br/>
                                based methods
                            </div>
                        </transition>
                    </proof>
            </div>
        </div>

        <div class="py-12 px-14">
            <progress-bar :progress="progress" class="w-full h-1.5 shrink-0" color="green"/>
        </div>
    </f-app-screen>
</template>

<script setup>
import ProgressBar from '@/components/ProgressBar.vue'
import Proof from '@/modules/core/onboarding/components/Proof.vue'
import { onMounted, ref } from 'vue'

const props = defineProps({
  progress: {
    type: Number,
    required: true
  }
})

const showProof = ref({
  1: false,
  2: false
})

onMounted(() => {
  Object.keys(showProof.value).forEach(key => {
    setTimeout(() => {
      showProof.value[key] = true
    }, key * 300)
  })
})
</script>
